<template>
  <div class="row">
    <loader v-if="loading"></loader>
    <div v-else>
      <h1>Adicionar Ação</h1>
      <hr>
      <div>
        <div class="form-group">
          <label for="name">Nome</label>
          <input id="name" class="form-control" v-model="newAction.name" placeholder="Nome">
        </div>
        <div class="form-group">
          <label for="description">Descrição</label>
          <textarea id="description" type="text" class="form-control" v-model="newAction.description"
                        placeholder="Descrição"></textarea>
        </div>
        <div class="form-group">
          <label for="type">Tipo</label>
          <select id="type" class="form-control" v-model="newAction.type" placeholder="Tipo" v-on:change="change()">
              <option v-for="fieldType in fieldTypes" v-bind:value="fieldType">{{fieldType}}</option>
          </select>
        </div>
        <div class="form-group" v-if="show">
          <label for="link">Link</label>
          <input id="link" class="form-control" v-model="newAction.value" placeholder="URL do link" type="url">
        </div>
        <button id="btn-save-field" type="button" class="btn btn-primary" @click="save">Salvar</button>
        <button type="button" class="btn btn-default" @click="cancel">Voltar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Parse,
  miniToastr
} from '../Global'

import Loader from './util/Loader'
import { handleParseError } from './util/ErrorHandling'

export default {
  components: {
    Loader
  },
  data () {
    return {
      loading: false,
      show: false,
      stepParse: null,
      newAction: {},
      newActionParse: {},
      fieldTypes: ['form', 'link']
    }
  },
  mounted () {
    let id = this.$route.params.id
    let stepId = this.$route.params.stepId
    this.getInformation(id, stepId)
  },
  methods: {
    getInformation (id, stepId) {
      let self = this
      self.loading = true
      let query = new Parse.Query('Step')
      query.get(stepId).then(result => {
        self.stepParse = result
        let queryAction = new Parse.Query('StepAction')
        return id ? queryAction.get(id) : Parse.Promise.as(false)
      }).then(result => {
        if (result) {
          self.newActionParse = result
          self.newAction = result.toJSON()
        }
        self.show = self.newAction.type === 'link'
        self.loading = false
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    },
    change () {
      this.show = this.newAction.type === 'link'
      this.newAction.value = null
    },
    cancel () {
      this.$router.go(-1)
    },
    save () {
      let self = this
      self.loading = true
      let StepAction = Parse.Object.extend('StepAction')
      let query = new Parse.Query(StepAction)
      query.equalTo('step', self.stepParse)
      query.count().then(count => {
        let action = new StepAction()
        action.set('step', self.stepParse)
        if (self.$route.params.id) {
          action.set('id', self.newAction.objectId)
        } else {
          action.set('order', count)
        }
        let props = ['name', 'description', 'type', 'value']
        props.forEach(attr => {
          action.set(attr, self.newAction[attr])
        })
        return action.save()
      }).then(result => {
        self.loading = false
        miniToastr.success('Salvo com sucesso')
        self.$router.go(-1)
      }).fail(error => {
        self.loading = false
        handleParseError(self, error)
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// StepActionDetail.vue?3a5cbf3b